import React, { useState } from "react"
import { Link } from "gatsby"
import Nav from "../nav"
import Spacer from "../spacer"
import "./header.css"
import logo from "../../images/logo.svg"
import { useWindowSize } from "../windowSize/windowSize"

const Header = () => {
  // Extracting the window width into a local variable
  const [width] = useWindowSize()

  // hold scroll height in state
  const [scrollHeight, setScrollHeight] = useState(0)

  // add event listener to update scroll height on scroll
  if (typeof window !== "undefined") {
    window.addEventListener("scroll", () => {
      setScrollHeight(window.scrollY)
    })
  }

  // Conditional background for header depending on scroll distance and device size
  const styles = {
    background:
      width > 1024
        ? "rgba(0, 0, 0, 0)"
        : scrollHeight > 80
        ? "rgba(0, 0, 0, 1)"
        : "rgba(0, 0, 0, 0)",
  }

  return (
    <header onClick={() => console.log(window)} style={styles}>
      {/* Logo */}
      <span style={{ height: "24px" }}>
        <Link to="/" id="logo" style={{ height: "100%" }}>
          <img src={logo} alt="Phresh Logo" style={{ height: "100%" }} />
        </Link>
      </span>
      {/* Spacer to go between the logo and nav */}
      <Spacer />
      {/* Nav component */}
      <Nav />
    </header>
  )
}

export default Header
